import apiClient from '../api/client';

/**
 * Direct-to-Stripe upgrade flow. No intermediate modal — caller passes a
 * Stripe price_tier string ('monthly' | 'annual' | 'naplex_crunch' |
 * 'mpje_crunch' | 'ptcb_crunch') and we mint a checkout session and
 * redirect.
 *
 * On error, falls back to navigating the user to the public /pricing page
 * so they're never stranded.
 */
export async function startStripeCheckout(priceTier, { fallbackNavigate } = {}) {
  try {
    const response = await apiClient.post('/api/stripe/create-checkout-session', {
      price_tier: priceTier,
      return_url: window.location.origin,
    });
    const url = response?.data?.checkout_url;
    if (!url) throw new Error('No checkout_url in response');
    window.location.href = url;
    return { ok: true };
  } catch (err) {
    if (typeof fallbackNavigate === 'function') {
      fallbackNavigate('/dashboard?checkout_failed=1');
    } else {
      window.location.href = '/dashboard?checkout_failed=1';
    }
    return { ok: false, error: err };
  }
}
